import React, { useEffect, useState } from "react";
import Header from "./Header";
import SubHeader from "./SubHeader";
import DataTable, { formatNum } from "./DataTable";
import TableLoader from "../TableLoader";
import Apiauth from "../../../API/Apiauth";
import LocationCharts from "./graph/LocationChart";

function mapRows(apiData = []) {
  return apiData.map((row) => ({
    location: row.location_Name,
    countryName: row.location_country,
    qty: row.qty,
    tagPrice: row.tag_price,
    sellingPrice: row.selling_price,
    invoice: row.invoice,
    upi: row.unit_per_invoice,
    aiv: row.aiv,
  }));
}

function mapTotals(apiTotals = {}) {
  return {
    qty: apiTotals.qty,
    tagPrice: apiTotals.tag_price,
    sellingPrice: apiTotals.selling_price,
    invoice: apiTotals.invoice,
    upi: apiTotals.unit_per_invoice,
    aiv: apiTotals.aiv,
  };
}

function mapMetrics(summary = {}) {
  return [
    { label: "Location", value: formatNum(summary.total_locations) },
    { label: "Top Location by Amount", value: summary.top_location_by_amount },
    { label: "Top Location by Qty", value: summary.top_location_by_qty },
    {
      label: "Lowest Performing Location",
      value: summary.lowest_performing_location,
    },
  ];
}

const DEFAULT_PAGE_SIZE = 10;
const CHART_MAX_LIMIT = 100000;
const Location = () => {
  const [rows, setRows] = useState([]);
  const [chartRows, setChartRows] = useState([]);
  const [totals, setTotals] = useState(null);
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [showCharts, setShowCharts] = useState(false);

  const DEFAULT_COLUMNS = [
    { key: "_index", label: "#", align: "center", width: 40 },
    { key: "location", label: "Location", align: "left", width: 230 },
    { key: "countryName", label: "Country Name", align: "left", width: 150 },
    { key: "qty", label: "Qty", align: "left", width: 100 },
    { key: "tagPrice", label: "Tag Price", align: "left", width: 120 },
    { key: "sellingPrice", label: "Selling Price", align: "left", width: 120 },
    { key: "invoice", label: "Invoice", align: "right", width: 100 },
    { key: "upi", label: "Unit Per Invoice - UPI", align: "right", width: 190 },
    {
      key: "aiv",
      label: "Average Item Value - AIV",
      align: "right",
      width: 200,
    },
  ];

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const fetchSalesLocReport = ({
    page: p = 1,
    limit: l = pageSize,
    ...rest
  } = {}) => {
    setLoading(true);
    Apiauth({ page: p, limit: l, ...rest }, "Inventory/reports/salesByLocation")
      .then((res) => {
        if (res?.code === 200) {
          setRows(mapRows(res.data));
          setTotals(mapTotals(res.totals));
          setMetrics(mapMetrics(res.summary));
          setFilter(res.filters);
          setTotalRecords(res?.pagination?.total ?? 0);
        }
      })
      .finally(() => setLoading(false));
  };

  const fetchSalesLocChartReport = (filters = {}) => {
    setLoading(true);
    Apiauth(
      { page: 1, limit: CHART_MAX_LIMIT, ...filters },
      "Inventory/reports/salesByLocation"
    )
      .then((res) => {
        if (res?.code === 200) {
          setChartRows(mapRows(res.data));
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSalesLocReport({ page: 1, limit: DEFAULT_PAGE_SIZE });
  }, []);

  useEffect(() => {
    if (showCharts) {
      fetchSalesLocChartReport(appliedFilters);
    }
  }, [showCharts, appliedFilters]);

  function handleFetchData({ page: newPage, limit: newLimit }) {
    if (newLimit !== pageSize) setPageSize(newLimit);
    setPage(newPage);
    fetchSalesLocReport({ ...appliedFilters, page: newPage, limit: newLimit });
  }

  function handleFilterApply(filterParams = {}) {
    setAppliedFilters(filterParams);
    setPage(1);
    fetchSalesLocReport({ ...filterParams, page: 1, limit: pageSize });
  }

  return (
    <>
      <Header title="Sales by Location" metrics={metrics} />
      <SubHeader filters={filter} showCharts={showCharts}  setShowCharts={setShowCharts} onFilterApply={handleFilterApply} />
      {loading ? (
        <TableLoader />
      ) : (
         showCharts?(<LocationCharts  rows={chartRows}/>):
       ( <DataTable
          columns={DEFAULT_COLUMNS}
          data={rows}
          totals={totals}
          showSearch={true}
          showDateRange={true}
          pageLimit={pageSize}
          totalRecords={totalRecords}
          currentPage={page}
          onPageChange={setPage}
          fetchData={handleFetchData}
        />)
      )}
    </>
  );
};

export default Location;
